// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const CONTEST_POSTS_OLD_CONTESTS = "Star\u0161\u00ed sout\u011b\u017ee...";
export const CONTEST_POSTS_TITLE = "Prob\u00edhaj\u00edci sout\u011b\u017ee";
